import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  filterEmptyChildNodes,
  getClipboardData,
  pasteAsText,
} from '../../utils'
import { nanoid } from '@reduxjs/toolkit'
import HelpTooltip from '../tooltip/HelpTooltip'
import classNames from 'classnames'

export const convertDangerouslyHTML = textContents =>
  textContents
    .map(item => `<span class='txt_tag' contenteditable='true'>${item}</span>`)
    .join('')

const KeywordContentEditableInput = ({
  keywords,
  onChange,
  title,
  tooltip,
  maxLength = 20,
}) => {
  const idRef = useRef(nanoid())
  const inputRef = useRef()
  const [count, setCount] = useState(keywords.length)
  const [focused, setFocused] = useState(false)

  useEffect(() => {
    setCount(keywords.length)
  }, [keywords])

  const handlePaste = event => {
    event.preventDefault()
    const text = getClipboardData(event)
    pasteAsText(text)
  }
  const handleInput = event => {
    const { childNodes } = event.target
    setCount(filterEmptyChildNodes(childNodes).length)
  }
  const handleKeyDown = event => {
    const { childNodes } = event.target
    const { length } = filterEmptyChildNodes(childNodes)
    setCount(length)
    if (length >= maxLength && event.key === 'Enter') {
      event.preventDefault()
    }
  }
  const handleFocus = () => {
    setFocused(true)
  }
  const handleChange = event => {
    setFocused(false)
    const { childNodes } = event.target
    const textContents = filterEmptyChildNodes(childNodes).slice(0, maxLength)
    onChange(textContents)
    event.target.innerHTML = convertDangerouslyHTML(textContents)
  }
  const handleLabelClick = () => {
    setTimeout(() => inputRef.current?.focus(), 0)
  }
  return (
    <div className="box_group">
      <div className="group_tit">
        <strong className="tit_group">
          {title}
          <HelpTooltip>{tooltip}</HelpTooltip>
        </strong>
        <div className="f_right">
          <span className="fc_emph">{count}</span>/20
        </div>
      </div>
      <div
        className={classNames('box_textarea', {
          on: focused,
        })}>
        {focused === false && count === 0 && (
          <label
            id={idRef.current}
            className="lab_txt"
            onMouseDown={handleLabelClick}>
            한 줄에 하나의 {title}을 입력하세요.
          </label>
        )}
        <div
          id={idRef.current}
          ref={inputRef}
          className="tf_area"
          contentEditable
          dangerouslySetInnerHTML={{
            __html: convertDangerouslyHTML(keywords),
          }}
          onInput={handleInput}
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleChange}
        />
      </div>
    </div>
  )
}
KeywordContentEditableInput.propTypes = {
  keywords: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
}
export default KeywordContentEditableInput
